export default "__VITE_ASSET__BL3oi0K5__"